var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_2114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1403 14.6666C9.98123 14.6666 11.6479 13.9204 12.8543 12.714C14.0608 11.5075 14.807 9.84085 14.807 7.99992C14.807 6.15899 14.0608 4.49232 12.8543 3.28587C11.6479 2.07945 9.98123 1.33325 8.1403 1.33325C6.29937 1.33325 4.6327 2.07945 3.42625 3.28587C2.21983 4.49232 1.47363 6.15899 1.47363 7.99992C1.47363 9.84085 2.21983 11.5075 3.42625 12.714C4.6327 13.9204 6.29937 14.6666 8.1403 14.6666Z",
    stroke: "#C9B65B",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14063 9.54159V8.20825C9.24519 8.20825 10.1406 7.31282 10.1406 6.20825C10.1406 5.10369 9.24519 4.20825 8.14063 4.20825C7.03606 4.20825 6.14062 5.10369 6.14062 6.20825",
    stroke: "#C9B65B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14095 12.5417C8.60118 12.5417 8.97428 12.1686 8.97428 11.7083C8.97428 11.2481 8.60118 10.875 8.14095 10.875C7.68072 10.875 7.30762 11.2481 7.30762 11.7083C7.30762 12.1686 7.68072 12.5417 8.14095 12.5417Z",
    fill: "#C9B65B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_2114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.140625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.81b41fa52c2cb8bd028a501f7a96a878.svg";
export { ForwardRef as ReactComponent };